import {
  ObalMaterialuVseobecnyApi,
  ObalMaterialu as ObalMaterialuDto, ObalMaterialuUpdate,
} from 'evidencna-aplikacia-frontend-ts-axios';
import apiConfiguration from '../../configuration/apiConfiguration';
import { evidenciaPrefixPath } from '../../configuration/apiConfigurationConstants';
import Uuid from '../../../model/Uuid';
import {
  ObalMaterialu,
} from '../../../model/sprievodnyDokument/obalMaterialu/ObalMaterialuFormData';
import { ClientResponse } from '../../../model/ClientResponse';

const client = new ObalMaterialuVseobecnyApi(apiConfiguration(evidenciaPrefixPath));

function mapToObalMaterialuDto(data: ObalMaterialu): ObalMaterialuDto {
  return {
    nazovVygenerovanehoDokumentu: data.nazovVygenerovanehoDokumentu,
    zodpovednaInstitucia: data.zodpovednaInstitucia,
    rezortneCislo: data.rezortneCislo,
    typObalu: data.typObalu,
    navrh: data.navrh,
    typMaterialu: data.typMaterialu,
    rok: data.rok,
    nazovMaterialu: data.nazovMaterialu,
    podnet: data.podnet,
    obsahMaterialu: data.obsahMaterialu,
    predkladatel: data.predkladatel,
    miestoDatum: data.miestoDatum,
  };
}

function mapToObalMaterialuUpdateDto(data: ObalMaterialu, sprievodnyDokumentUuid: Uuid): ObalMaterialuUpdate {
  return {
    obalMaterialu: mapToObalMaterialuDto(data),
    sprievodnyDokumentUuid,
  };
}

export const createObalMaterialuVseobecnyClient = async (
  legMaterialUuid: Uuid,
  formData: ObalMaterialu,
  stadiumUuid?: Uuid,
  headers?: object,
): Promise<ClientResponse<void>> => {
  const {
    status,
  } = await client.createVseobecnyObalMaterialu(legMaterialUuid, mapToObalMaterialuDto(formData), stadiumUuid, headers);

  return {
    responseCode: status,
  };
};

export const editObalMaterialuVseobecnyClient = async (
  legMaterialUuid: Uuid,
  formData: ObalMaterialu,
  sprievodnyDokumentUuid: Uuid,
  stadiumUuid?: Uuid,
  headers?: object,
): Promise<ClientResponse<void>> => {
  const {
    status,
  } = await client.updateVseobecnyObalMaterialu(
    legMaterialUuid,
    mapToObalMaterialuUpdateDto(formData, sprievodnyDokumentUuid),
    stadiumUuid,
    headers,
  );

  return {
    responseCode: status,
  };
};
